<template>
	<div style="display: flex;align-items: center;flex-direction: column;">

		<el-card class="box-card" style="width: 95%;" v-loading="!r.r1">
			<div>
				<div style="display: flex;align-items: center; height: 5vh;">
					<div style="font-size: 110%;margin-bottom: 10px;">康复数据</div>
					<el-col :span="14"
						style="display: flex;align-items: center;margin-bottom: 10px; margin-left: 30px;">
						<div class="sub-title">时长标准:</div>
						<el-input placeholder="时长标准分钟" v-model="kechen_bz"
							style="width: 10vw; zoom:80%; font-size: 110%; margin-left: 10px;" clearable>
						</el-input>
						<el-button @click="tijiao" type="primary" style="zoom: 75% ; margin-left: 1vw;">提交</el-button>
					</el-col>
				</div>
				<div class="aflex">
					<div>
						<div class="agrey atitle">转介儿童数</div>
						<div v-if="r.r1" class="atitle shuzi1">{{r.r1.num}}</div>
					</div>
					<div>
						<div class="agrey atitle">0-6周岁</div>
						<div v-if="r.r2" class="atitle shuzi1">{{r.r2.num}}</div>
					</div>
					<div>
						<div class="agrey atitle">户籍外市儿童数</div>
						<div v-if="r.r1" class="atitle shuzi1">{{r.r3.num}}</div>
					</div>
					<div>
						<div class="agrey atitle">孤独症儿童数</div>
						<div v-if="r.r1" class="atitle shuzi1">{{r.r4.num}}</div>
					</div>
					<div>
						<div class="agrey atitle">“机构集中”</div>
						<div v-if="r.r1" class="atitle shuzi1">{{r.r5.num}}</div>
					</div>
				</div>
			</div>
		</el-card>
		<div style="display: flex;justify-content: space-around;width: 100%;margin-top: 10px;">
			<el-card style="height: calc( 100vh - 285px);width: 45%;">
				<div>
					<!-- <div style="font-size: 105%;margin-bottom: 5px;">机构分布情况(共{{hosps.length}}家机构)    当前为选择为：<el-button style=" margin-top: 5px;" size="mini" :type="orgname=='本地机构'? 'success':'primary'">{{orgname}}</el-button></div>
					<el-button style="margin-bottom: 5px;" @click="shudi" size="mini" type="success">本地机构</el-button>
					<el-button style="margin-bottom: 5px;" @click="shudi1" size="mini" type="primary">异地机构</el-button> -->

					<!-- <el-table v-if="orgname=='本地机构'" height="calc( 100vh - 360px)" size="mini" :data="hosps" border style="width: 94%">
						<el-table-column type="index" label="序号" width="50">
						</el-table-column>
						<el-table-column prop="qu_name" label="区县">
						</el-table-column>
						<el-table-column prop="label" label="机构名">
						</el-table-column>
						<el-table-column prop="value" label="学生数" width="80">
						</el-table-column>
					</el-table> -->
					<el-table height="calc( 100vh - 360px)" size="mini" :data="hosps" border style="width: 94%">
						<el-table-column type="index" label="序号" width="50">
						</el-table-column>
						<el-table-column prop="label" label="机构名">
						</el-table-column>
						<el-table-column prop="value" label="学生数" width="80">
						</el-table-column>
					</el-table>

				</div>
			</el-card>
			<el-card style="height: calc( 100vh - 285px);width: 45%;">
				<div v-if="$store.state.org.area!='371100000000'">
					<div style="font-size: 105%;margin-bottom: 10px;">类别分布情况</div>
					<el-table height="calc( 100vh - 360px)" size="mini" :data="types" border style="width: 94%">
						<el-table-column type="index" label="序号" width="50">
						</el-table-column>
						<el-table-column prop="label" label="残疾类型">
						</el-table-column>
						<el-table-column prop="value" label="学生数" width="80">
						</el-table-column>
					</el-table>
				</div>
				<div v-else>
					<div style="font-size: 105%;margin-bottom: 10px;">地区分布情况</div>
					<el-table height="calc( 100vh - 360px)" size="mini" :data="areas" border style="width: 94%">
						<el-table-column type="index" label="序号" width="50">
						</el-table-column>
						<el-table-column prop="name" label="地区">
						</el-table-column>
						<el-table-column prop="num" label="儿童数" width="80">
						</el-table-column>
					</el-table>
				</div>
			</el-card>
		</div>
	</div>
</template>

<script>
	import shuzi from "../shuzi.vue"
	export default {
		data() {
			return {
				r: {},
				hosps: [],
				types: [],
				areas: [],
				// orgname:"本地机构",
				selectform: {
					name: "",
					hosp: "",
					status: ""
				},
				kechen_bz: '',
				kechen_info: null,
				restaurants: [],
			}
		},
		components: {
			shuzi
		},
		mounted() {
			this.restaurants = this.loadAll();
		},
		props: {
			year: Number
		},
		watch: {
			year(newVal) {
				this.gethosps(newVal)
				this.gettypes(newVal)
				this.getallr()
			}
		},
		computed: {
			info() {
				let info = window.localStorage.getItem("info");
				return JSON.parse(info);
			},
			org() {
				let org = window.localStorage.getItem("org");
				return JSON.parse(org);
			}
		},
		methods: {
			loadAll() {
				return [{
					"value": "180分钟",
					"address": "180"
				}];
			},
			querySearch(queryString, cb) {
				var restaurants = this.restaurants;
				var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
				// 调用 callback 返回建议列表的数据
				cb(results);
			},
			// 本地机构
			shudi() {
				this.orgname = "本地机构"

			},
			// 异地机构
			shudi1() {
				this.orgname = "异地机构"
			},
			async getareas() {
				let ans = await axios.get(this.$url + 'hospital/areatotal', {
                  params:{
					token: this.info.uid
				  }
				});
				this.areas = ans.data;

			},
			async gettypes() {
				let ans = await axios.get(this.$url + 'hospital/tptotal', {
					params: {
						qu_id: this.org.area,
						nian: this.year,
						token: this.info.uid
					}
				});
				this.types = []
				ans.data.lists.map(async p => {
					this.types.push({
						value: p.num,
						label: p.name
					});
				})

			},
			handleSelect(item) {
				console.log(item);
			},
			async get_time_bz() {
				// 获取标准
				let ans = await axios.get(this.$urls + 'canlian/cnalian_shichang', {
					params: {
						qu_id: this.org.area,
						type: "selec",
						token: this.info.uid
					},
					headers: {
						"teatoken": this.teatoken
					}
				});
				this.kechen_bz = ans.data.data.time_xlsx == undefined ? "" : ans.data.data.time_xlsx
				this.kechen_info = ans.data.data
				console.log(this.kechen_info);
			},
			async tijiao() {
				let ans = await axios.get(this.$urls + 'canlian/cnalian_shichang', {
					params: {
						qu_id: this.org.area,
						time_xlsx: this.kechen_bz,
						type: "updat",
						id: this.kechen_info.id
					}
				});
				if (ans.data.status == 1) {
					this.$message({
						message: `${ans.data.desc}`,
						type: 'success'
					});
				} else {
					this.$message.error(`${ans.data.desc}`);
				}
				await this.get_time_bz()
			},
			async gethosps(newVal) {
				let ans = await axios.get(this.$url + 'hospital/asd_kf_hosps', {
					params: {
						qu_id: this.org.area,
						nian: this.year,
						token: this.info.uid
					}
				});
				this.hosps = []
				console.log(ans.data, "ssssss");
				ans.data.lists.map(async p => {
					this.hosps.push({
						value: p.ob,
						label: p.hosp,
						qu_name: p.canlian
					});
				});
			},
			async getallr() {
				let ans = await axios.get(this.$url + 'hospital/static', {
					params: {
						qu_id: this.org.area,
						nian: this.year,
						token: this.info.uid
					}
				});
				console.log(ans.data, "ans.data");
				this.r = ans.data.r;
			}
		},
		async created() {
			console.log(this.year, '00000000000000000000');
			this.getallr();
			this.gethosps();
			this.gettypes();
			this.get_time_bz()
			if (this.org.area == '371100000000') {
				this.getareas();
			}
		}
	}
</script>

<style>
	.shuzi1 {
		padding: 10px 10px;
		font-size: 140%;
	}

	.aflex {
		display: flex;
		justify-content: space-around;
		align-items: center;
	}
</style>